import React from "react";

import { NavLink } from "react-router-dom";
import { Menu } from "antd";
import type { MenuProps } from "antd";
import Icon from "@/components/Icon";
import { URLS } from "@/urls";

const SuperAdminMenuItems = (props) => {
  const {
    defaultOpenKeys,
    defaultSelectedKeys,
    selectedKeys,
    onOpenChange,
    optionalMenuProps,
    onMenuItemClick,
  } = props;

  const items: MenuProps["items"] = [
    {
      key: URLS.dashboard.index.buildPath(),
      icon: <Icon icon={"faTachometerAlt"} />,
      label: (
        <NavLink to={URLS.dashboard.index.buildPath()}>
          <span>Dashboard</span>
        </NavLink>
      ),
    },
    {
      key: URLS.orderManagement.key.buildPath(),
      icon: <Icon icon={"faDollarSign"} />,
      label: <span>Orders</span>,
      children: [
        {
          key: URLS.orderManagement.orders.list.buildPath(),
          label: (
            <NavLink to={URLS.orderManagement.orders.list.buildPath()}>
              <Icon icon={"faListAlt"} />
              <span>Orders</span>
            </NavLink>
          ),
        },
        {
          key: URLS.orderManagement.workflows.index.buildPath(),
          label: (
            <NavLink to={URLS.orderManagement.workflows.index.buildPath()}>
              <Icon icon={"faTrello"} brand /> <span>Workflows</span>
            </NavLink>
          ),
        },
      ],
    },
    {
      key: URLS.serviceManagement.key.buildPath(),
      icon: <Icon icon={"faNetworkWired"} />,
      label: <span>Services</span>,
      children: [
        {
          key: URLS.serviceManagement.circuits.list.buildPath(),
          label: (
            <NavLink to={URLS.serviceManagement.circuits.list.buildPath()}>
              <Icon icon={"faEthernet"} /> <span>Circuits</span>
            </NavLink>
          ),
        },
        {
          key: URLS.serviceManagement.devicesAndContracts.key.buildPath(),
          label: (
            <span>
              <Icon icon={"faHdd"} /> <span>Devices</span>
            </span>
          ),
          children: [
            {
              key: URLS.serviceManagement.devicesAndContracts.devices.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.serviceManagement.devicesAndContracts.devices.list.buildPath()}
                >
                  Devices
                </NavLink>
              ),
            },
            {
              key: URLS.serviceManagement.devicesAndContracts.maintenanceContracts.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.serviceManagement.devicesAndContracts.maintenanceContracts.list.buildPath()}
                >
                  Maintenance Contracts
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.serviceManagement.locations.list.buildPath(),
          label: (
            <NavLink to={URLS.serviceManagement.locations.list.buildPath()}>
              <Icon icon={"faMapMarker"} /> <span>Locations</span>
            </NavLink>
          ),
        },
        {
          key: URLS.serviceManagement.services.list.buildPath(),
          label: (
            <NavLink to={URLS.serviceManagement.services.list.buildPath()}>
              <Icon icon={"faNetworkWired"} /> <span>Services</span>
            </NavLink>
          ),
        },
        {
          key: URLS.serviceManagement.mobile.key.buildPath(),
          label: (
            <span>
              <Icon icon={"faMobileAlt"} /> <span>Mobile M2M</span>
            </span>
          ),
          children: [
            {
              key: URLS.serviceManagement.mobile.cellularSIMCards.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.serviceManagement.mobile.cellularSIMCards.list.buildPath()}
                >
                  Cellular SIM
                </NavLink>
              ),
            },
            {
              key: URLS.serviceManagement.mobile.cellularSIMCardChangeLogs.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.serviceManagement.mobile.cellularSIMCardChangeLogs.list.buildPath()}
                >
                  Change Logs
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.serviceManagement.mobileVoice.key.buildPath(),
          label: (
            <NavLink
              to={URLS.serviceManagement.mobileVoice.simCards.list.buildPath()}
            >
              <Icon pro icon={"faMobile"} /> <span>NetSG Mobile v1</span>
            </NavLink>
          ),
        },
        {
          key: URLS.serviceManagement.netsgMobile.key.buildPath(),
          label: (
            <span>
              <Icon pro icon={"faMobile"} /> <span>NetSG Mobile v2</span>
            </span>
          ),
          children: [
            {
              key: URLS.serviceManagement.netsgMobile.services.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.serviceManagement.netsgMobile.services.list.buildPath()}
                >
                  Services
                </NavLink>
              ),
            },
            {
              key: URLS.serviceManagement.netsgMobile.pools.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.serviceManagement.netsgMobile.pools.list.buildPath()}
                >
                  Data Pools
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.serviceManagement.managedServices.list.buildPath(),
          label: (
            <NavLink
              to={URLS.serviceManagement.managedServices.list.buildPath()}
            >
              <Icon icon={"faNetworkWired"} /> <span>Managed Services</span>
            </NavLink>
          ),
        },
      ],
    },
    {
      key: URLS.clientManagement.key.buildPath(),
      icon: <Icon icon={"faUsers"} />,
      label: <span>Clients</span>,
      children: [
        {
          key: URLS.clientManagement.companies.list.buildPath(),
          label: (
            <NavLink to={URLS.clientManagement.companies.list.buildPath()}>
              <Icon icon={"faBuilding"} /> <span>Companies</span>
            </NavLink>
          ),
        },
        {
          key: URLS.clientManagement.contacts.list.buildPath(),
          label: (
            <NavLink to={URLS.clientManagement.contacts.list.buildPath()}>
              <Icon icon={"faUser"} /> <span>Contacts</span>
            </NavLink>
          ),
        },
      ],
    },
    {
      key: URLS.changeManagement.key.buildPath(),
      icon: <Icon icon={"faCogs"} />,
      label: <span>Change Management</span>,
      children: [
        {
          key: URLS.changeManagement.calendar.buildPath(),
          label: (
            <NavLink to={URLS.changeManagement.calendar.buildPath()}>
              <Icon icon={"faCalendar"} />
              <span>Calendar</span>
            </NavLink>
          ),
        },
        {
          key: URLS.changeManagement.changes.list.buildPath(),
          label: (
            <NavLink to={URLS.changeManagement.changes.list.buildPath()}>
              <Icon icon={"faEnvelope"} />
              <span>Notifications</span>
            </NavLink>
          ),
        },
        {
          key: URLS.changeManagement.requests.list.buildPath(),
          label: (
            <NavLink to={URLS.changeManagement.requests.list.buildPath()}>
              <Icon icon={"faListAlt"} />
              <span>Requests</span>
            </NavLink>
          ),
        },
      ],
    },
    {
      key: URLS.voiceBilling.key.buildPath(),
      icon: <Icon icon={"faPhone"} />,
      label: <span>Voice</span>,
      children: [
        {
          key: URLS.voiceBilling.SIPTrunks.list.buildPath(),
          label: (
            <NavLink to={URLS.voiceBilling.SIPTrunks.list.buildPath()}>
              <Icon icon={"faPhoneOffice"} pro /> <span>SIP Trunks</span>
            </NavLink>
          ),
        },
        {
          key: URLS.voiceBilling.phoneNumberRanges.list.buildPath(),
          label: (
            <NavLink to={URLS.voiceBilling.phoneNumberRanges.list.buildPath()}>
              <Icon icon={"faListOl"} /> <span>Phone Number Ranges</span>
            </NavLink>
          ),
        },
        {
          key: URLS.voiceBilling.answerPoints.list.buildPath(),
          label: (
            <NavLink to={URLS.voiceBilling.answerPoints.list.buildPath()}>
              <Icon icon={"faPhone"} pro /> <span>Answer Points</span>
            </NavLink>
          ),
        },
      ],
    },
    {
      key: URLS.reports.key.buildPath(),
      icon: <Icon icon={"faList"} />,
      label: <span>Reports</span>,
      children: [
        {
          key: URLS.reports.invoices.buildPath(),
          label: (
            <NavLink to={URLS.reports.invoices.buildPath()}>
              <span>
                <Icon icon={"faFileInvoiceDollar"} />
                <span>Invoices</span>
              </span>
            </NavLink>
          ),
        },
        {
          key: URLS.reports.circuitsStartDateDelta.buildPath(),
          label: (
            <NavLink to={URLS.reports.circuitsStartDateDelta.buildPath()}>
              <Icon icon={"faEthernet"} />
              <span>Circuits Date Delta</span>
            </NavLink>
          ),
        },
        {
          key: URLS.reports.ordersPDDStatus.buildPath(),
          label: (
            <NavLink to={URLS.reports.ordersPDDStatus.buildPath()}>
              <Icon icon={"faShoppingBag"} />
              <span>Orders PDD Status</span>
            </NavLink>
          ),
        },
        {
          key: URLS.reports.deviceFirmware.buildPath(),
          label: (
            <NavLink to={URLS.reports.deviceFirmware.buildPath()}>
              <Icon icon={"faServer"} />
              <span>Device Firmware</span>
            </NavLink>
          ),
        },
        {
          key: URLS.reports.devicesPerManagedService.buildPath(),
          label: (
            <NavLink to={URLS.reports.devicesPerManagedService.buildPath()}>
              <Icon icon={"faNetworkWired"} />
              <span>Devices per Agreement</span>
            </NavLink>
          ),
        },
        {
          key: URLS.reports.siteDeploymentStatus.buildPath(),
          label: (
            <NavLink to={URLS.reports.siteDeploymentStatus.buildPath()}>
              <Icon icon={"faMapMarkedAlt"} />
              <span>Site Deployment Status</span>
            </NavLink>
          ),
        },
      ],
    },
    {
      key: URLS.admin.key.buildPath(),
      icon: <Icon icon={"faWrench"} />,
      label: <span>Admin</span>,
      children: [
        {
          key: URLS.admin.userAndGroups.key.buildPath(),
          label: "Users and Groups",
          children: [
            {
              key: URLS.admin.userAndGroups.users.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.userAndGroups.users.list.buildPath()}>
                  Users
                </NavLink>
              ),
            },
            {
              key: URLS.admin.userAndGroups.userGroups.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.userAndGroups.userGroups.list.buildPath()}
                >
                  User Groups
                </NavLink>
              ),
            },
            {
              key: URLS.admin.userAndGroups.permissions.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.userAndGroups.permissions.list.buildPath()}
                >
                  Permissions
                </NavLink>
              ),
            },
            {
              key: URLS.admin.userAndGroups.permissionsSets.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.userAndGroups.permissionsSets.list.buildPath()}
                >
                  Permissions Sets
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.admin.circuitsAndDevices.key.buildPath(),
          label: "Circuits and Devices",
          children: [
            {
              key: URLS.admin.circuitsAndDevices.circuitTypes.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.circuitsAndDevices.circuitTypes.list.buildPath()}
                >
                  Circuit Types
                </NavLink>
              ),
            },
            {
              key: URLS.admin.circuitsAndDevices.deviceManufacturers.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.circuitsAndDevices.deviceManufacturers.list.buildPath()}
                >
                  Device Types
                </NavLink>
              ),
            },
            {
              key: URLS.admin.circuitsAndDevices.deviceCategories.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.circuitsAndDevices.deviceCategories.list.buildPath()}
                >
                  Device Categories
                </NavLink>
              ),
            },
            {
              key: URLS.admin.circuitsAndDevices.deviceTags.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.circuitsAndDevices.deviceTags.list.buildPath()}
                >
                  Device Tags Library
                </NavLink>
              ),
            },
            {
              key: URLS.admin.circuitsAndDevices.bandwidths.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.circuitsAndDevices.bandwidths.list.buildPath()}
                >
                  Bandwidths
                </NavLink>
              ),
            },
            {
              key: URLS.admin.circuitsAndDevices.interfaceTypes.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.circuitsAndDevices.interfaceTypes.list.buildPath()}
                >
                  Interface Types
                </NavLink>
              ),
            },
            {
              key: URLS.admin.circuitsAndDevices.interfaceConfigurations.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.circuitsAndDevices.interfaceConfigurations.list.buildPath()}
                >
                  Interface Configurations
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.admin.provisioning.customerStatuses.list.buildPath(),
          label: (
            <NavLink
              to={URLS.admin.provisioning.customerStatuses.list.buildPath()}
            >
              Customer Statuses
            </NavLink>
          ),
        },
        {
          key: URLS.admin.vendorManagement.key.buildPath(),
          label: "Vendor Management",
          children: [
            {
              key: URLS.admin.vendorManagement.carriers.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.vendorManagement.carriers.list.buildPath()}
                >
                  Carriers
                </NavLink>
              ),
            },
            {
              key: URLS.admin.vendorManagement.maintenanceOrganizations.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.vendorManagement.maintenanceOrganizations.list.buildPath()}
                >
                  Maintenance
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.admin.emailSettings.key.buildPath(),
          label: "Email Settings",
          children: [
            {
              key: URLS.admin.emailSettings.emailSettings.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.emailSettings.emailSettings.list.buildPath()}
                >
                  Email Settings
                </NavLink>
              ),
            },
            {
              key: URLS.admin.emailSettings.emails.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.emailSettings.emails.list.buildPath()}>
                  Email Tracking
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.admin.productManagement.key.buildPath(),
          label: "Product Management",
          children: [
            {
              key: URLS.admin.productManagement.serviceCategories.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.productManagement.serviceCategories.list.buildPath()}
                >
                  Service Categories
                </NavLink>
              ),
            },
            {
              key: URLS.admin.productManagement.serviceTypes.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.productManagement.serviceTypes.list.buildPath()}
                >
                  Service Types
                </NavLink>
              ),
            },
            {
              key: URLS.admin.productManagement.mobilePlans.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.productManagement.mobilePlans.list.buildPath()}
                >
                  NetSG Mobile Plans
                </NavLink>
              ),
            },
            {
              key: URLS.admin.productManagement.mobileAddons.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.productManagement.mobileAddons.list.buildPath()}
                >
                  NetSG Mobile Bolt-Ons
                </NavLink>
              ),
            },
            {
              key: URLS.admin.productManagement.handoverDocumentTemplates.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.productManagement.handoverDocumentTemplates.list.buildPath()}
                >
                  Handover Templates
                </NavLink>
              ),
            },
            {
              key: URLS.admin.productManagement.workPlanTemplates.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.productManagement.workPlanTemplates.list.buildPath()}
                >
                  Work Plan Templates
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.admin.connectwise.key.buildPath(),
          label: "ConnectWise",
          children: [
            {
              key: URLS.admin.connectwise.syncEvents.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.connectwise.syncEvents.list.buildPath()}
                >
                  Sync Events
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.admin.netbrm.key.buildPath(),
          label: "Billing (NetBRM)",
          children: [
            {
              key: URLS.admin.netbrm.overview.index.buildPath(),
              label: (
                <NavLink to={URLS.admin.netbrm.overview.index.buildPath()}>
                  Overview
                </NavLink>
              ),
            },
            {
              key: URLS.admin.netbrm.inboundOrders.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.netbrm.inboundOrders.list.buildPath()}>
                  Inbound Orders
                </NavLink>
              ),
            },
            {
              key: URLS.admin.netbrm.mappings.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.netbrm.mappings.list.buildPath()}>
                  Catalog Mappings
                </NavLink>
              ),
            },
            {
              key: URLS.admin.netbrm.commands.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.netbrm.commands.list.buildPath()}>
                  Sync Queue
                </NavLink>
              ),
            },
            {
              key: URLS.admin.netbrm.links.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.netbrm.links.list.buildPath()}>
                  Links
                </NavLink>
              ),
            },
            {
              key: URLS.admin.netbrm.companyBilling.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.netbrm.companyBilling.list.buildPath()}>
                  Company Billing
                </NavLink>
              ),
            },
            {
              key: URLS.admin.netbrm.accountLinks.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.netbrm.accountLinks.list.buildPath()}>
                  Accounts
                </NavLink>
              ),
            },
            {
              key: URLS.admin.netbrm.restrictionDecisions.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.netbrm.restrictionDecisions.list.buildPath()}
                >
                  Restriction Decisions
                </NavLink>
              ),
            },
            {
              key: URLS.admin.netbrm.events.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.netbrm.events.list.buildPath()}>
                  Webhook Events
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.admin.voiceBilling.key.buildPath(),
          label: "Voice",
          children: [
            {
              key: URLS.admin.voiceBilling.voiceCodecs.list.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.voiceBilling.voiceCodecs.list.buildPath()}
                >
                  Voice Codecs
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.admin.formBuilder.key.buildPath(),
          label: "Form Builder",
          children: [
            {
              key: URLS.admin.formBuilder.templates.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.formBuilder.templates.list.buildPath()}>
                  Templates
                </NavLink>
              ),
            },
            {
              key: URLS.admin.formBuilder.forms.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.formBuilder.forms.list.buildPath()}>
                  Forms
                </NavLink>
              ),
            },
          ],
        },
        {
          key: URLS.admin.operations.key.buildPath(),
          label: "Operations",
          children: [
            {
              key: URLS.admin.operations.circuitRelocation.index.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.operations.circuitRelocation.index.buildPath()}
                >
                  Circuit Relocation
                </NavLink>
              ),
            },
            {
              key: URLS.admin.operations.tagManagement.index.buildPath(),
              label: (
                <NavLink
                  to={URLS.admin.operations.tagManagement.index.buildPath()}
                >
                  Tag Management
                </NavLink>
              ),
            },
            {
              key: URLS.admin.serviceMessages.list.buildPath(),
              label: (
                <NavLink to={URLS.admin.serviceMessages.list.buildPath()}>
                  Service Messages
                </NavLink>
              ),
            },
          ],
        },
      ],
    },
  ];

  return (
    <Menu
      mode="inline"
      theme={"light"}
      defaultOpenKeys={defaultOpenKeys}
      defaultSelectedKeys={defaultSelectedKeys}
      selectedKeys={selectedKeys}
      onOpenChange={onOpenChange}
      onClick={onMenuItemClick}
      style={{ height: "100%", borderRight: 0 }}
      items={items}
      {...optionalMenuProps}
    />
  );
};

export default SuperAdminMenuItems;
